import React from "react";
import Label from "../atoms/Label";
import { markdownToJSX } from "../../util/transforms";
import ReadMore from "../molecules/ReadMore";
import Image from "../atoms/Image";
import Link from "../atoms/Link";

export default ({ image, categoryText, title, text, readMoreText, url, subtitle }) =>
    <div className="o-blog-image-text">
        { image &&
        <div className="o-blog-image-text__image u-object-fit u-object-fit--3-2">
            <Link link={ { internalLink: { slug: url } } }>
                <Image className="u-object-fit__media" image={ image }/>
            </Link>
        </div>
        }
        <div className="o-blog-image-text__content">
            <Label isRed text={ categoryText } classes="o-blog-image-text__label"/>
            <div className="o-blog-image-text__title heading heading--fsl">
                <Link className="o-blog-image-text__link" link={ { internalLink: { slug: url } } }>{ markdownToJSX(title) }</Link>
            </div>
            <Label classes="o-blog-image-text__subtitle" text={ subtitle }/>
            <p>{ text }</p>
            <ReadMore isRed text={ readMoreText } link={ { internalLink: { slug: url } } }/>
        </div>
    </div>;
